import { MenuItem, MenuList } from '@mui/material';
import { LogOutIcon } from 'assets/icons/LogOutIcon';
import styled from 'styled-components';
import { colorPalette, getSpacing, typography } from 'stylesheet';

export const MenuContainer = styled.div`
  padding: ${getSpacing(1)};
  border-radius: ${getSpacing(2)};
  background-color: ${colorPalette.white};
  border: 1px solid ${colorPalette.grey_300};
  border-top: none;
  min-width: 155px;
  width: fit-content;
  margin-top: 20px;
  margin-right: 0;
  position: relative;
`;

export const StyledMenuList = styled(MenuList)`
  overflow: auto;
  padding: 0;
`;

export const InvoiceNotificationContainer = styled.div`
  padding: ${getSpacing(1)};
  border-radius: ${getSpacing(2)};
  background-color: ${colorPalette.white};
  border: 1px solid ${colorPalette.grey_300};
`;

export const InvoiceNotificationType = styled.div`
  margin-left: 16px;
`;

export const NotificationHeader = styled.h1`
  font-weight: bold;
  font-size: inherit;
`;
export const LanguageSettingContainer = styled.div`
  padding: ${getSpacing(1)};
  border-radius: ${getSpacing(2)};
  background-color: ${colorPalette.white};
  border: 1px solid ${colorPalette.grey_300};
`;
export const LanguageSettingHeader = styled.h1`
  font-weight: bold;
  font-size: inherit;
`;

export const StyledMenuItem = styled(MenuItem)`
  display: flex;
  border-radius: ${getSpacing(2)};
  padding: ${getSpacing(1)};
  &:hover {
    background-color: transparent;
  }
`;

export const StyledLogOutIcon = () => <LogOutIcon color={colorPalette.status_error} />;

export const MenuText = styled.span`
  margin-left: ${getSpacing(2)};
`;

export const DisconnectText = styled(MenuText)`
  color: ${colorPalette.status_error};
  font-weight: bold;
`;

export const SummaryScheduleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${getSpacing(0.5)};
  max-width: 280px;
  margin-top: ${getSpacing(1)};
`;

export const SummaryScheduleText = styled.span`
  ${typography.p1_regular};
  color: ${colorPalette.greyMain};
`;

export const SummaryScheduleNextRun = styled.span`
  ${typography.p1_regular};
  color: ${colorPalette.grey_600};
`;
